import * as React from 'react';
import * as PropTypes from 'prop-types';
import { st, classes } from './CoreTagsList.st.css';
import { filterDataProps } from '../../utils/FilterDataProps';
export const noop = () => null;
export const CoreTagsList = ({ children, className, onChange = noop, ...rest } = {}) => (React.createElement("div", { className: st(classes.root, className), ...filterDataProps(rest), "data-hook": "tags-list" /* DataHooks.TagsList */, onChange: onChange, role: "group", ...rest }, children));
CoreTagsList.displayName = "CoreTagsList" /* DisplayNames.TagsList */;
CoreTagsList.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onChange: PropTypes.func,
};
//# sourceMappingURL=CoreTagsList.js.map